export const Routes = {
  Home: "/",
  Demo: "/demo",
  Authenticate: "/authenticate",
  AuthenticateMobile: "/authenticateMobile",
  Login: "/login",
  ProfileSettings: "/profile/settings",
  Table: "/table",
  Nav: "/nav",
  Select: "/select",
  Admin: "/admin",
  AdminUsers: "/admin/users",
  UserManagement: "/user-management",
  AuditLogs: "/admin/audit-logs",
  FeatureCacheAdmin: "/admin/feature-cache",
  AdminLocalisation: "/admin/localisation",
  SuperAdminLocalisation: "/admin/localisation-management",
  Debug: "/admin/debug",
  Model: "/admin/model",
  ProductSetup: "/admin/product-setup",
  AdminFirmware: "/admin/firmware",
  SoilSamples: "/admin/soil-samples",
  SoilSampleCreate: "/admin/soil-samples/create",
  SoilSampleDetails: "/admin/soil-samples/:id",

  PDFExport: "/export-to-pdf/:key/:id",
  TrainedIndicators: "/admin/trained-indicators",
  NotFound: "/404",
  AppNotAvailable: "/app-not-available",
  PesTests: "/admin/pes-tests",
  PesTestDetails: "/admin/pes-tests/:id",
  ComparePesTests: "/admin/pes-tests/compare",
  UserDashboard: "/dashboard",
  UserTestDetails: "/test/:id",
  UserTestCompare: "/compare",
  AdminDashboard: "/admin/dashboard",
  Customers: "/admin/customers",
  AdminCassettes: "/admin/cassettes",
  AdminCassetteDetails: "/admin/cassettes/:id",
  AdminTROs: "/admin/tros",
};

export function getRoute(
  route: string,
  params?: { [key: string]: string }
): string {
  let path = route;
  if (params) {
    Object.keys(params).forEach((key) => {
      path = path.replace(`:${key}`, params[key]);
    });
  }
  return path;
}
